export default __webpack_public_path__ + "static/media/WM0380.34I-43155_-25812_0.c2f56d87.jpg";